"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.futuresProductsReducer = void 0;
var futuresProductsReducer = exports.futuresProductsReducer = function futuresProductsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    data: [],
    loaded: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'RECEIVE_FUTURES_PRODUCTS':
      return {
        data: action.payload,
        loaded: true
      };
    default:
      return state;
  }
};